// import { useState, useMemo, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import { getColumns } from "./columns";
// import Filter from "./Filter";
// import RoleTabs from "./RoleTabs";
// import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
// import ConfirmationModal from "./ConfirmationModal";
// import BreakReportDialog from "./BreakReportDialog";

// const INITIAL_FILTER_STATE = {
//   employeeName: "",
//   active: "",
//   employeeId: "",
//   branch: null,
//   role: "",
// };

// const fieldMappings = {
//   employeeName: ["full_name", "$contains"],
//   active: ["status", "$eq"],
//   employeeId: ["assigned_user_id", "$eq"],
//   branch: ["branch_code", "$eq"],
//   role: ["role_id", "$eq"],
// };

// const valueTransformers = {
//   // Convert boolean active to 1/0
//   active: (value) => {
//     if (value === "Active") return 1;
//     if (value === "Inactive") return 0;
//     return value; // Return original value if not boolean
//   },
//   branch: (value) => {
//     if (typeof value === "object") {
//       return value?.branch_code || value;
//     }
//     return value;
//   },
//   // Convert date to ISO string if needed
//   // lastSyncedStart: (value) =>
//   //   value instanceof Date ? value.toISOString() : value,
//   // lastSyncedEnd: (value) =>
//   //   value instanceof Date ? value.toISOString() : value,
// };

// // Derive initial state from URL
// const getInitialRole = (location) => {
//   // Prioritize activeRole from location.state if available
//   if (location.state?.activeRole) {
//     return location.state.activeRole;
//   }

//   // Fallback to deriving role from pathname
//   const path = location?.pathname;
//   if (path && path.includes("/users/all")) return "All";

//   const pathParts = path && path.split("/");
//   if (pathParts && pathParts.length >= 3) {
//     const roleSlug = pathParts[2];
//     const roleFormatted = roleSlug
//       .replace(/-/g, " ")
//       .replace(/\b\w/g, (l) => l.toUpperCase());
//     return roleFormatted;
//   }
//   return "All";
// };

// export default function UsersTable({ type = "all" }) {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [selectedUserForBreakReport, setSelectedUserForBreakReport] =
//     useState(null);
//   const [roles, setRoles] = useState([]);
//   const [activeRole, setActiveRole] = useState(() => getInitialRole(location));
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [open, setOpen] = useState(false);
//   const [openDeleteUser, setOpenDeleteUser] = useState(false);
//   const [openBreakReport, setOpenBreakReport] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [addEmployee,setAddEmployee] = useState({});
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0, // DataGrid uses 0-based indexing
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);

//   const [sortModel, setSortModel] = useState([]);

//   const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
//   const [refreshList, setRefreshList] = useState(false); // To refetch the list after some actions/api call without page reload manually by user

//   const { currentBranch } = useBranch();

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   const fetchUsers = async (
//     page = 1,
//     pageSize = 20,
//     filters = submittedData,
//     sortInfo = sortModel
//   ) => {
//     setLoading(true);

//     const endpoint = `users/${type}`;

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);

//       const { data } = res;
//       setAddEmployee({data});
// // console.log("the data check", data)
//       if (data.status === 200) {
//         setUsers(data.data);
//         setRowCount(data.meta?.total || data.count || 0);
//         setRoles(data.roles);
//         setRefreshList(false);
//       } else {
//         showNotification("error", data.msg);
//       }
//     } catch (error) {
//       if (error.response.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers(
//       paginationModel.page + 1,
//       paginationModel.pageSize,
//       submittedData,
//       sortModel
//     );
//   }, [
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleChangeStatus = () => {
//     setLoading(true);

//     const API_URL = `users/${selectedUser.id}/status`;

//     try {
//       httpclient.post(API_URL).then(({ data }) => {
//         if (data.status === 200) {
//           showNotification("success", data.message);
//           setSelectedUser("");
//           setOpenStatusChangeModal(false);
//           setRefreshList(true);
//         } else {
//           showNotification("error", data.message);
//         }
//       });
//     } catch (error) {
//       console.log(error, "error changing status");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update activeRole when location changes, but only if state.activeRole is not set
//   useEffect(() => {
//     const newRole = getInitialRole(location);
//     setActiveRole(newRole);
//   }, [location]);

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: setUsers,
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: `users/${type}`,
//     fieldMappings,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = (field) => {
//     // Create new filter data without the removed field
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     // Reset the field in filterData (UI state)
//     newFilterData[field] = field === "branch" ? null : "";

//     // Remove the field from submittedData (API state)
//     delete newSubmittedData[field];

//     // Update states
//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     // Trigger API call with remaining filters
//     handleFilter(newFilterData);
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleAddEmployee = () => {
//     navigate("/users/add", { state: { activeRole } });
//   };

//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     navigate(`/users/edit/${user.id}`, { state: { activeRole } });
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     // Reset to the first page when sorting changes
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDeleteUser = async () => {
//     setActionLoading(true);
//     const API_URL = `users/delete/${selectedUser.id}`;
//     try {
//       const { data } = await httpclient.delete(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedUser("");
//         setOpenDeleteUser(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         setTimeout(() => {
//           setOpenDeleteUser(false); // Close modal
//         }, 1000);
//       } else if (error.response?.status === 401) {
//         refresh();
//       }
//       handleApiError(error);
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleClearOrder = async () => {
//     setActionLoading(true);

//     const API_URL = `users/${selectedUser.id}/clear-orders`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedUser("");
//         setOpen(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         setTimeout(() => {
//           setOpen(false); // Close modal
//         }, 1000);
//       } else if (error.response?.status === 401) {
//         refresh();
//       }

//       handleApiError(error);
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const hasClearOrders = useMemo(() => {
//     return users.some((row) => row.clear_order_log_button_enabled === 1);
//   }, [users]);

//   const hasOnBreakStatus = users.some(
//     (user) => user.app_status && user.app_status.includes("On Break")
//   );

//   const columns = getColumns(
//     handleEdit,
//     setOpenDeleteUser,
//     setOpen,
//     setSelectedUser,
//     setOpenStatusChangeModal,
//     hasClearOrders,
//     hasOnBreakStatus,
//     setOpenBreakReport,
//     setSelectedUserForBreakReport
//   );

//   const deleteUserMessage = (
//     <>
//       Are you sure you want to delete <strong>{selectedUser?.full_name}</strong>
//     </>
//   );

//   const clearOrdersMessage = (
//     <>
//       Are you sure you want to clear all orders for user:{" "}
//       <strong>{selectedUser?.full_name}</strong>
//     </>
//   );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <RoleTabs activeRole={activeRole} />
//           </Grid>
          
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//           >
            
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: "4px",
//                 backgroundColor: "#7152F3",
//                 "&:hover": {
//                   backgroundColor: "#5c34fa",
//                 },
//               }}
//               startIcon={<img src={AddUserIcon} alt="Add User" />}
//               onClick={handleAddEmployee}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   textTransform: "none",
//                 }}
//               >
//                 Add New Employee
//               </Typography>
//             </Button>
            
//             <img
//               src={filterOpen ? FilterBtnUp : FilterBtn}
//               alt="Filter"
//               style={{ cursor: "pointer" }}
//               onClick={() => setFilterOpen(!filterOpen)}
//             />
//           </Grid>
          
//           <Filter
//             roles={roles}
//             filterOpen={filterOpen}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={onFilterClick}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//           />
//         </Grid>

//         <DataGrid
//           rows={users || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel} // Controlled sort model
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//         {openStatusChangeModal && (
//           <StatusChangeConfirmationModal
//             open={openStatusChangeModal}
//             cancel={() => setOpenStatusChangeModal(false)}
//             title="Change Status"
//             item={selectedUser?.full_name}
//             loading={loading}
//             selectedUser={selectedUser}
//             handleChangeStatus={handleChangeStatus}
//           />
//         )}
//         {open && (
//           <ConfirmationModal
//             open={open}
//             handleClose={() => setOpen(false)}
//             title={"Clear Orders"}
//             message={clearOrdersMessage}
//             selectedUser={selectedUser}
//             onConfirm={handleClearOrder}
//             actionLoadingText="Clearing..."
//             ActionBtnText="Clear"
//             loading={actionLoading}
//           />
//         )}

//         {openDeleteUser && (
//           <ConfirmationModal
//             open={openDeleteUser}
//             handleClose={() => setOpenDeleteUser(false)}
//             title={"Delete User"}
//             message={deleteUserMessage}
//             selectedUser={selectedUser}
//             onConfirm={handleDeleteUser}
//             actionLoadingText="Deleting..."
//             ActionBtnText="Delete"
//             loading={actionLoading}
//           />
//         )}

//         {openBreakReport && (
//           <BreakReportDialog
//             open={openBreakReport}
//             onClose={() => setOpenBreakReport(false)}
//             selectedUser={selectedUserForBreakReport}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }


// ******************************************************************************************************************

import { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Typography, Grid } from "@mui/material";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../Utils";
import { createFilterHandler } from "../../../../Utils/FilterUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { useBranch } from "../../../../Hooks/useBranch";
import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

import { getColumns } from "./columns";
import Filter from "./Filter";
import RoleTabs from "./RoleTabs";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import ConfirmationModal from "./ConfirmationModal";
import BreakReportDialog from "./BreakReportDialog";

const INITIAL_FILTER_STATE = {
  employeeName: "",
  userName: "",
  active: "",
  employeeId: "",
  branch: null,
  role: "",
};

const fieldMappings = {
  employeeName: ["full_name", "$contains"],
  userName: ["user_name", "$contains"],
  active: ["status", "$eq"],
  employeeId: ["assigned_user_id", "$eq"],
  branch: ["branch_code", "$eq"],
  role: ["role_id", "$eq"],
};

const valueTransformers = {
  // Convert boolean active to 1/0
  active: (value) => {
    if (value === "Active") return 1;
    if (value === "Inactive") return 0;
    return value; // Return original value if not boolean
  },
  branch: (value) => {
    if (typeof value === "object") {
      return value?.branch_code || value;
    }
    return value;
  },
  // Convert date to ISO string if needed
  // lastSyncedStart: (value) =>
  //   value instanceof Date ? value.toISOString() : value,
  // lastSyncedEnd: (value) =>
  //   value instanceof Date ? value.toISOString() : value,
};

// Derive initial state from URL
const getInitialRole = (location) => {
  // Prioritize activeRole from location.state if available
  if (location.state?.activeRole) {
    return location.state.activeRole;
  }

  // Fallback to deriving role from pathname
  const path = location?.pathname;
  if (path && path.includes("/users/all")) return "All";

  const pathParts = path && path.split("/");
  if (pathParts && pathParts.length >= 3) {
    const roleSlug = pathParts[2];
    const roleFormatted = roleSlug
      .replace(/-/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
    return roleFormatted;
  }
  return "All";
};

const getCachedRoles = () => {
  try {
    const cached = sessionStorage.getItem("users_roles_cache");
    return cached ? JSON.parse(cached) : [];
  } catch {
    return [];
  }
};

export default function UsersTable({ type = "all" }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserForBreakReport, setSelectedUserForBreakReport] =
    useState(null);
  const [roles, setRoles] = useState(getCachedRoles);
  const [activeRole, setActiveRole] = useState(() => getInitialRole(location));
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const [open, setOpen] = useState(false);
  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [openBreakReport, setOpenBreakReport] = useState(false);

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [addEmployeePermission, setAddEmployeePermission] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0, // DataGrid uses 0-based indexing
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);

  const [sortModel, setSortModel] = useState([]);

  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false); // To refetch the list after some actions/api call without page reload manually by user

  const { currentBranch } = useBranch();

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchUsers = async (
    page = 1,
    pageSize = 20,
    filters = submittedData,
    sortInfo = sortModel
  ) => {
    setLoading(true);

    const endpoint = `users/${type}`;

    const apiUrl = buildApiQuery(endpoint, {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      filters: submittedData,
      sortModel,
      fieldMappings,
      valueTransformers,
    });

    try {
      const res = await httpclient.get(apiUrl);

      const { data } = res;
      
      // Store the permission data
      setAddEmployeePermission({
        allow_add: data.allow_add
      });

      if (data.status === 200) {
        setUsers(data.data);
        setRowCount(data.meta?.total || data.count || 0);
        setRoles(data.roles);
        try {
          sessionStorage.setItem("users_roles_cache", JSON.stringify(data.roles));
        } catch {
          // ignore storage errors (e.g. private browsing)
        }
        setRefreshList(false);
      } else {
        showNotification("error", data.msg);
      }
    } catch (error) {
      if (error.response.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(
      paginationModel.page + 1,
      paginationModel.pageSize,
      submittedData,
      sortModel
    );
  }, [
    refreshList,
    currentBranch,
    paginationModel.page,
    paginationModel.pageSize,
    sortModel,
    submittedData,
  ]);

  const handleChangeStatus = () => {
    setLoading(true);

    const API_URL = `users/${selectedUser.id}/status`;

    try {
      httpclient.post(API_URL).then(({ data }) => {
        if (data.status === 200) {
          showNotification("success", data.message);
          setSelectedUser("");
          setOpenStatusChangeModal(false);
          setRefreshList(true);
        } else {
          showNotification("error", data.message);
        }
      });
    } catch (error) {
      console.log(error, "error changing status");
    } finally {
      setLoading(false);
    }
  };

  // Update activeRole when location changes, but only if state.activeRole is not set
  useEffect(() => {
    const newRole = getInitialRole(location);
    setActiveRole(newRole);
  }, [location]);

  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: setUsers,
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: `users/${type}`,
    fieldMappings,
    valueTransformers,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    // Create new filter data without the removed field
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    // Reset the field in filterData (UI state)
    newFilterData[field] = field === "branch" ? null : "";

    // Remove the field from submittedData (API state)
    delete newSubmittedData[field];

    // Update states
    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    // Trigger API call with remaining filters
    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleAddEmployee = () => {
    navigate("/users/add", { state: { activeRole } });
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    navigate(`/users/edit/${user.id}`, { state: { activeRole } });
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    // Reset to the first page when sorting changes
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleDeleteUser = async () => {
    setActionLoading(true);
    const API_URL = `users/delete/${selectedUser.id}`;
    try {
      const { data } = await httpclient.delete(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedUser("");
        setOpenDeleteUser(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setTimeout(() => {
          setOpenDeleteUser(false); // Close modal
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      }
      handleApiError(error);
    } finally {
      setActionLoading(false);
    }
  };

  const handleClearOrder = async () => {
    setActionLoading(true);

    const API_URL = `users/${selectedUser.id}/clear-orders`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedUser("");
        setOpen(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setTimeout(() => {
          setOpen(false); // Close modal
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      }

      handleApiError(error);
    } finally {
      setActionLoading(false);
    }
  };

  const hasClearOrders = useMemo(() => {
    return users.some((row) => row.clear_order_log_button_enabled === 1);
  }, [users]);

  const hasOnBreakStatus = users.some(
    (user) => user.app_status && user.app_status.includes("On Break")
  );

  const columns = getColumns(
    handleEdit,
    setOpenDeleteUser,
    setOpen,
    setSelectedUser,
    setOpenStatusChangeModal,
    hasClearOrders,
    hasOnBreakStatus,
    setOpenBreakReport,
    setSelectedUserForBreakReport
  );

  const deleteUserMessage = (
    <>
      Are you sure you want to delete <strong>{selectedUser?.full_name}</strong>
    </>
  );

  const clearOrdersMessage = (
    <>
      Are you sure you want to clear all orders for user:{" "}
      <strong>{selectedUser?.full_name}</strong>
    </>
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <RoleTabs activeRole={activeRole} roles={roles} />
          </Grid>
          
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
          >
            {/* Conditionally show Add New Employee button based on allow_add permission */}
            {addEmployeePermission.allow_add === 1 && (
              <Button
                variant="contained"
                sx={{
                  borderRadius: "4px",
                  backgroundColor: "#7152F3",
                  "&:hover": {
                    backgroundColor: "#5c34fa",
                  },
                }}
                startIcon={<img src={AddUserIcon} alt="Add User" />}
                onClick={handleAddEmployee}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Add New 
                </Typography>
              </Button>
            )}
            
            <img
              src={filterOpen ? FilterBtnUp : FilterBtn}
              alt="Filter"
              style={{ cursor: "pointer" }}
              onClick={() => setFilterOpen(!filterOpen)}
            />
          </Grid>
          
          <Filter
            roles={roles}
            filterOpen={filterOpen}
            filterData={filterData}
            handleChangeFilter={handleChangeFilter}
            handleFilter={onFilterClick}
            handleClearFilters={handleClearFilters}
            handleRemove={handleRemove}
            submittedData={submittedData}
          />
        </Grid>

        <DataGrid
          rows={users || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel} // Controlled sort model
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />
        {openStatusChangeModal && (
          <StatusChangeConfirmationModal
            open={openStatusChangeModal}
            cancel={() => setOpenStatusChangeModal(false)}
            title="Change Status"
            item={selectedUser?.full_name}
            loading={loading}
            selectedUser={selectedUser}
            handleChangeStatus={handleChangeStatus}
          />
        )}
        {open && (
          <ConfirmationModal
            open={open}
            handleClose={() => setOpen(false)}
            title={"Clear Orders"}
            message={clearOrdersMessage}
            selectedUser={selectedUser}
            onConfirm={handleClearOrder}
            actionLoadingText="Clearing..."
            ActionBtnText="Clear"
            loading={actionLoading}
          />
        )}

        {openDeleteUser && (
          <ConfirmationModal
            open={openDeleteUser}
            handleClose={() => setOpenDeleteUser(false)}
            title={"Delete User"}
            message={deleteUserMessage}
            selectedUser={selectedUser}
            onConfirm={handleDeleteUser}
            actionLoadingText="Deleting..."
            ActionBtnText="Delete"
            loading={actionLoading}
          />
        )}

        {openBreakReport && (
          <BreakReportDialog
            open={openBreakReport}
            onClose={() => setOpenBreakReport(false)}
            selectedUser={selectedUserForBreakReport}
          />
        )}
      </Box>
    </Box>
  );
}
